import { ApiService } from '../../../types/api';
import type { ActionDetailResponse, ActionsResponse, StaffActionCategory } from '../types';

export interface StaffApiContract {
  actions(teamId: number, category: StaffActionCategory): Promise<ActionsResponse>;
  action(
    teamId: number,
    category: StaffActionCategory,
    actionType: string,
  ): Promise<ActionDetailResponse>;
  performAction(
    teamId: number,
    category: StaffActionCategory,
    actionType: string,
    payload: Record<string, unknown>,
  ): Promise<void>;
}

declare module '../../../context/page-context' {
  interface Apis {
    staff: StaffApiContract;
  }
}

export class StaffApi extends ApiService implements StaffApiContract {
  public actions(teamId: number, category: StaffActionCategory): Promise<ActionsResponse> {
    return this.api.fetch<ActionsResponse>({
      method: 'GET',
      path: `/staff/teams/${teamId}/${category}`,
    });
  }

  public action(
    teamId: number,
    category: StaffActionCategory,
    actionType: string,
  ): Promise<ActionDetailResponse> {
    return this.api.fetch<ActionDetailResponse>({
      method: 'GET',
      path: `/staff/teams/${teamId}/${category}/${actionType}`,
    });
  }

  public performAction(
    teamId: number,
    category: StaffActionCategory,
    actionType: string,
    payload: Record<string, unknown>,
  ): Promise<void> {
    return this.api.fetch<void>({
      method: 'POST',
      path: `/staff/teams/${teamId}/${category}/${actionType}`,
      payload: { payload },
    });
  }
}
